import { Component, Inject } from '@angular/core';
import { MatDialogRef,  MAT_DIALOG_DATA, MatDialog} from '@angular/material/dialog';
import { Post, Template } from '../container';
import { FirestoreService } from '../firestore-service.service';
import { ConfirmingDialogComponent } from '../confirming-dialog/confirming-dialog.component';
import { Router } from '@angular/router';
import { ChangeDetectorRef } from '@angular/core';
import { DetailsforpageComponent } from '../detailsforpage/detailsforpage.component';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-addworkpackagedialog',
    templateUrl: './addworkpackagedialog.component.html',
    styleUrls: ['./addworkpackagedialog.component.scss'],
    imports: [
      CommonModule,
      DetailsforpageComponent,
      ConfirmingDialogComponent
    ],
    standalone: true
})
export class AddworkpackagedialogComponent {
  contentKey = ""
  menuItems: {key: string, name: string, color: string}[] = [];
  templates: Template[] = [];
  post: Post = {"authorKey": "", "authorName": "", "categoryKey": "", "color": "", "commentCount": 0, "nameHTML": "", "contentRowsCount": 0, "coverImageURL": "", "dateOfCreation": new Date(), "dateOfUpdate": new Date(), "fields": [], "formattedDate": "", "imageURLs": [], "isDeleted": false, "isDownloadAvailable": false, "isNewPost": true, "key": "", "lastCommentDate": new Date(), "loggedUserDisplayName": "", "loggedUserKey": "", "organizationKey": "", "name": "", "projectKey": "", "projectName": "", "tags": [], "templateKey": "", "title": "", "viewCount": 0, "contentType": "", "embedding": [], "isRead": false, "isTop": false, "isFavourite": false, "progressPercent": 0, "startDate": new Date(), "endDate": new Date(), "manHours": 0, "isSelected": false, "templateName": "", "isCompleted": false, "parentName": "", "areKidsColored": false, "description": "", "assignedUsers": [], "status": "", "sequence": 0, "parentKey": "", "isExpanded": false, "areKidsTagged": false, "milestoneKey": "", "isChecked": false, "isParent": false, "fileType": ""};
  isAutofocusSet: boolean = false
  projectName: string = "";
  userId: string = "";
  userDisplayName: string = "";
  isAnonymous: boolean = true
  organizationKey: string = "";
  projectKey: string = "";
  channelKey: string = "";
  type: string = ""; // type of content workpackage, post, comment
  channelName = ""
  channelPath = ""
  showAddTemplatePopup = false
  addTemplateName = ""
  percentage = 0;
  imageURLs: string[] = []
  postKey = ""
  linkedPosts: Post[] = [];
  isAddPostClicked: boolean = false
  addedPostLink: string = ""
  fieldKeyWithLinks: number = -1
  parentName = "";
  name = "";
  color = "";
  blindColor = "#888888";
  areKidsColored: boolean = true
  areKidsTagged: boolean = true
  templateKey: string = "note"
  templateIndex: number = -1
  isDeleted = false
  isCompleted = false
  isRead = false
  isTop = false
  isFavourite = false
  token = ""
  showUserDetailsModal = false
  isPostUpdated = false
  globalTags: string[] = []
  tutorialTooltips: {"object": string, "tooltipSelector": string, "tooltipCaption": string}[] = [
    {"object": "#header", "tooltipSelector": "#tooltippopup", "tooltipCaption": "Here you can see details of a task or a note"},
    {"object": "#template", "tooltipSelector": "#tooltippopup", "tooltipCaption": "Each record is created based on predefined templates."},
    {"object": "#section", "tooltipSelector": "#tooltippopup", "tooltipCaption": "But you can rearrange sequence of sections and add new ones."},
    {"object": "#save", "tooltipSelector": "#tooltippopup", "tooltipCaption": "Click here to save your updates and quit."},
  ]
  tutorialTooltipMessage = ""
  columns: {"key": string, "name": string, "sequence": number}[] = []
  statusName = ""
  columnKey = ""
  isReadOnly = false
  isLoadingLabelVisible = false
  didJustPaste = false
  fieldToBeReplacedWhenPasting = -1
  embeddingModel = ""
  captureImage = false // if true, capture image from camera immediately after user clicks post details
  startDate = new Date()
  endDate = new Date()
  manHours = 0
  progressPercent = 0
  selectedTeamKey = ""

  constructor(public dialogRef: MatDialogRef<AddworkpackagedialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private firestoreService: FirestoreService, private dialog: MatDialog, private router: Router, private cdr: ChangeDetectorRef) { 
    console.log("addworkpackagedialog component constructor")
    this.type = this.data.type
    this.post = this.data.post;
    this.isCompleted = data.isCompleted
    this.post.fields = data.fields
    this.templates = this.data.templates;
    this.menuItems = this.data.menuItems;
    this.userId = this.data.userId
    this.organizationKey = this.data.organizationKey
    this.projectKey = this.data.projectKey
    this.projectName = this.data.projectName
    this.channelKey = this.data.channelKey
    this.parentName = this.data.parentName
    this.columnKey = this.data.columnKey
    this.isReadOnly = this.data.isReadOnly
    this.templateKey = this.data.templateKey
    this.globalTags = this.data.globalTags
    this.captureImage = this.data.captureImage || false
    this.color = this.data.color || "#ffffff"
    this.embeddingModel = this.data.embeddingModel
    this.startDate = this.data.startDate
    this.endDate = this.data.endDate
    this.manHours = this.data.manHours
    this.progressPercent = this.data.progressPercent
    this.selectedTeamKey = this.data.selectedTeamKey
    if (this.embeddingModel == undefined) {
      this.embeddingModel = "gemini-embedding-001"
    }
    if (this.isReadOnly == undefined) {
      this.isReadOnly = false
    }
    firestoreService.getKanbanColumns(this.organizationKey, this.projectKey).then(result => {
      this.columns = result
      for (let i = 0; i < this.columns.length; i++) {
        if (this.columns[i].key == this.columnKey) {
          this.statusName = this.columns[i].name
        }
      }
      this.columns.sort((a, b) => {
        return a.sequence - b.sequence;
      });
    })
  
    for (let i = 0; i < data.fields.length; i++) {
      if (data.fields[i].content == "" && data.fields[i].type == "label") { // fill in labels if they are empty, this happens when new task is added
        data.fields[i].content = data.fields[i].placeholder
      }
    }
    if (this.color == null) {
      this.color = "#ffffff"
    }
    let HTMLname = this.data.HTMLname
    if ((HTMLname == undefined)||(HTMLname == "")) {
      this.name = this.data.name
    } else {
      this.name = this.data.HTMLname
    }
    this.fieldKeyWithLinks = data.fieldKeyWithLinks
    this.isPostUpdated = false // open dialog for view only at first
    this.postKey = this.data.key
  }

  ngAfterViewInit() {
    console.log("addworkpackagedialog component ngAfterViewInit")
    if (this.isDeleted == true) {
      this.dialogRef.close()
      this.dialog.closeAll();
      this.dialog.open(ConfirmingDialogComponent, {
        width: '400px',
        data: {"content": "This content has been deleted.", "onlyCloseButton": true}
      });
    }
    if (this.color == "#ffffff") {
      this.color = this.blindColor
    }
  }

  close(result: {isDeleted: boolean, isPostUpdated: boolean, isListening: boolean, name: string, htmlName: string}) {
    this.data.isDeleted = result.isDeleted
    this.data.isPostUpdated = result.isPostUpdated
    this.data.isListening = result.isListening
    this.data.name = result.name
    this.data.htmlName = result.htmlName
   // this.dialogRef.close(this.data)
  }

  updateDelete(event: {isDeleted: boolean, selectedShapeKey: string}) { // fired when content is deleted in content-details
    this.data.isDeleted = event.isDeleted
    this.data.selectedShapeKey = event.selectedShapeKey
  }

  updateStatus(columnKey: string) {
    this.data.columnKey = columnKey
  }

  updateColor(color: string) {
    this.data.color = color
  }

  updateName(result: {name: string, htmlName: string}) {
    this.data.htmlName = result.htmlName
    this.data.name = result.name
  }

  updateComplete(isCompleted: boolean) {
    this.data.isCompleted = isCompleted
  }

  updateCoverImage(url: string) {
    this.data.coverImageURL = url
  }
}
